import { Subject } from 'rxjs';

const subject = new Subject<string>();

export const LoadVideoBgService = {
    sendNomeVideo: (msg: string) => subject.next(msg),
    getNomeVideo: () => subject.asObservable()
};